import { render, staticRenderFns } from "./EmailPreSets.vue?vue&type=template&id=3514458a&scoped=true&"
import script from "./EmailPreSets.vue?vue&type=script&lang=js&"
export * from "./EmailPreSets.vue?vue&type=script&lang=js&"
import style0 from "./EmailPreSets.vue?vue&type=style&index=0&id=3514458a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3514458a",
  null
  
)

export default component.exports